import { combineReducers } from "redux";
import { createSelector } from "reselect";

import { createReducer, updateObject } from "./utils";

import { getTrueLockingsSelector } from "./lockings";

import * as ActionTypes from "../app/ActionTypes";

/*
	Reducer cases
*/

function getRolesSuccess(state, action) {
	return action.mappedRights;
}

// FIXME: server need to send just updated role
function saveRoleSuccess(state, action) {
	return action.mappedRights;
}

function deleteRoleRequest(state, action) {
	/*
		HANDLE DELETE
	*/
	const newState = { ...state };
	delete newState[action.roleId]
	return newState;
}

function deleteLockingRequest(state, action) {
	const newState = { ...state };
	const keys = Object.keys(state)
	keys.forEach(key =>
		delete newState[key][action.lockingId]
		// if(key === action.lockingId)
		// 	delete newState[]
	)
	return newState
}

function addRightsRequest(state, action) {
	const newState = { ...state };
	action.rolesIds.forEach(roleId =>
		action.lockingsIds.forEach(lockingId =>
			newState[roleId][lockingId] = true
		)
	);
	return newState;
}

function deleteRightsRequest(state, action) {
	const newState = { ...state };
	action.rolesIds.forEach(roleId => {
		action.lockingsIds.forEach(lockingId => {
			delete newState[roleId][lockingId]
		})
	});
	return newState;
}

/*
	Reducer
*/

const reducer = combineReducers({
	byRoleIds: createReducer({}, {
		[ActionTypes.GET_ROLES_SUCCESS]			: getRolesSuccess,
		// FIXME: server need to send just updated role
		[ActionTypes.SAVE_ROLE_SUCCESS]			: saveRoleSuccess,
		[ActionTypes.DELETE_ROLE_REQUEST]		: deleteRoleRequest,
		[ActionTypes.DELETE_LOCKING_REQUEST]	: deleteLockingRequest,
		[ActionTypes.ADD_RIGHT_REQUEST]			: addRightsRequest,
		[ActionTypes.DELETE_RIGHT_REQUEST]		: deleteRightsRequest,
	})
});

/**
*	Selectors
*/
const rightsSelector = state => state.entities.rights.byRoleIds;

/* FIXME: IMPLETING IT OWN REDUCER: rights: { byLockingsIds: {} } */
const getRightsByLockingsIdSelector = createSelector(
	getTrueLockingsSelector,
	rightsSelector,
	(lockings, rightsByRoleIds) => {
		const map = {};
		const rolesIds = Object.keys(rightsByRoleIds);
		rolesIds.forEach(roleId => {
			const lockingsIds = Object.keys(rightsByRoleIds[roleId]);
			lockingsIds.forEach(lockingId => {
				if(!map[lockingId]) {
					map[lockingId] = {}
				}
				map[lockingId][roleId] = true;
			});
		});
		// Add missing lockings (those had no rights)
		lockings.forEach(locking => {
			if(!map[locking.locking_id]) {
				map[locking.locking_id] = {};
			}
		})
		return map;
	}
);


export default reducer;
export { rightsSelector, getRightsByLockingsIdSelector };



// WEBPACK FOOTER //
// ./src/js/reducers/rights.js